import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class PostContentCharCounterForm extends FormBase {
    public getTextareas(root: ParentNode): HTMLTextAreaElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.POST_CONTENT}"], textarea[name="content"]`,
            HTMLTextAreaElement,
        );
    }

    public getBoardContent(root: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, ".board-content", HTMLElement);
    }

    public getCounter(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, "[data-post-content-counter]", HTMLElement);
    }

    public getCount(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, "[data-post-content-count]", HTMLElement);
    }

    public getProgressFill(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, "[data-post-content-progress-fill]", HTMLElement);
    }

    public getThreshold(root: ParentNode, threshold: string): HTMLElement | null {
        return this.queryElement(root, `[data-post-content-threshold="${threshold}"]`, HTMLElement);
    }

    public getEmbeds(root: ParentNode): HTMLElement[] {
        return this.queryElements(
            root,
            "iframe, video, audio, embed, object, img, figure.ql-video, .ql-video, oembed, blockquote[data-embed-url], [data-embed]",
            HTMLElement,
        );
    }
}

const postContentCharCounterForm = new PostContentCharCounterForm();

export { PostContentCharCounterForm, postContentCharCounterForm };
